export const readEventStream = async (response, onEvent = () => {}) => {
  if (!response.ok) {
    let payload = {};
    try { payload = await response.json(); } catch (_) { /* response is not JSON */ }
    throw new Error(payload.error || `HTTP ${response.status}`);
  }
  if (!response.body) throw new Error('Streaming response is unavailable');

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let result = null;

  const dispatch = (frame) => {
    if (!frame || frame.startsWith(':')) return;
    let event = 'message';
    const data = [];
    frame.split('\n').forEach(line => {
      if (line.startsWith('event:')) event = line.slice(6).trim();
      if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
    });
    if (!data.length) return;
    const payload = JSON.parse(data.join('\n'));
    if (event === 'error') throw new Error(payload.error || 'Streaming search failed');
    if (event === 'result') result = payload;
    onEvent(event, payload);
  };

  while (true) {
    const { done, value } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    buffer = buffer.replace(/\r\n/gu, '\n');
    let boundary = buffer.indexOf('\n\n');
    while (boundary >= 0) {
      dispatch(buffer.slice(0, boundary));
      buffer = buffer.slice(boundary + 2);
      boundary = buffer.indexOf('\n\n');
    }
    if (done) break;
  }
  if (buffer.trim()) dispatch(buffer.trim());
  if (!result) throw new Error('Streaming search ended without a result');
  return result;
};
